import React from 'react';

import { Checkbox } from 'components/WrappedComponents';
import { CSSUtils } from 'utils/CSSUtils';

import { FilterDashboardFourriereProps } from '../../../types';

function CheckboxEmptyIdAlienation({
  values,
}: FilterDashboardFourriereProps): React.ReactElement {
  return (
    <Checkbox
      wrapperProps={{
        values: values,
        fieldKey: 'emptyIdAlienation',
        itemProps: {
          label: 'Id Alienation manquant',
          labelCol: { span: CSSUtils.defaultLabelCol },
          wrapperCol: { span: CSSUtils.mediumWrapperCol },
        },
      }}
      checkboxProps={{}}
    />
  );
}

export default CheckboxEmptyIdAlienation;
